import { createUseRepositoryQuery } from '@mews/framework';
import { useRepositoryRegistry } from './RepositoryRegistryContext';

export const useRepositoryQuery = createUseRepositoryQuery(useRepositoryRegistry);
